export const changeCropNameSelectedReducer = (state = "", action) => {
  switch (action.type) {
    case "CHANGE_CropNameSelected":
      return action.payload.cropNameSelected;
    default:
      return state;
  }
};
